module.exports = __webpack_public_path__ + "images/cebsblogo_white.1791450974374.png";